<script setup lang="ts">
const userStore = useUserStore()
const modalStore = useModalStore()
</script>

<template>
  <div class="py-4">
    <div class="relative pt-16 pb-16 overflow-hidden bg-white rounded-md shadow">
      <div class="relative">
        <div class="lg:mx-auto lg:max-w-8xl lg:px-8 lg:grid lg:grid-cols-2 lg:grid-flow-col-dense lg:gap-24">
          <div class="max-w-xl px-4 mx-auto sm:px-6 lg:py-16 lg:max-w-none lg:mx-0 lg:px-0">
            <div>
              <div>
                <span class="flex items-center justify-center w-12 h-12 rounded-md bg-tomate-400">
                  <UIcon name="i-mdi-format-list-checkbox" class="w-6 h-6 text-white" aria-hidden="true" />
                </span>
              </div>
              <div class="mt-6">
                <h2 class="text-3xl font-extrabold tracking-tight text-poivre-800 font-title">
                  La liste d'épicerie réinventée
                </h2>
                <p class="mt-4 text-lg text-poivre-500">
                  Ajoutez des articles depuis n'importe quel outil ou recette sur Glouton. Vous pouvez ensuite modifer, classer votre liste et même retrouver la recette d'un ingrédient précis de votre liste.
                </p>
                <div class="mt-4 text-lg text-poivre-500">
                  <p>Vous pouvez aussi ajouter des spéciaux depuis Glouton. Pour éviter les surprises, les spéciaux expirés sont clairement indiqués.</p>
                </div>
                <div class="mt-4 text-lg text-poivre-500">
                  <p>Facilitez-vous la vie avec des sous-listes: par supermarché, sections de l'épicerie, recette, événement ou autre.</p>
                </div>
                <h3 class="mt-4 text-2xl font-extrabold tracking-tight text-poivre-800 font-title">
                  Des fonctionnalités intelligentes
                </h3>
                <div class="mt-4 text-lg text-poivre-500">
                  <ul class="list-disc pl-5">
                    <li>Une gestion précise des quantités;</li>
                    <li>Un contrôle flexible avec les sous-listes;</li>
                    <li>Les articles encerclés directement sur la circulaire;</li>
                    <li>Les articles expirés supprimés en un clic;</li>
                    <li>Et bien plus...</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="pt-6 mt-8 border-t border-poivre-200">
              <blockquote>
                <div>
                  <p class="text-base text-poivre-500">
                    «Une liste pour tout, modifiable comme je veux. J'ajoute les ingrédients par ma tablette et ma liste me suit sur mon téléphone intelligent à l'épicerie.»
                  </p>
                </div>
                <footer class="mt-3">
                  <div class="flex items-center space-x-3">
                    <div class="flex-shrink-0">
                      <img class="w-6 h-6 rounded-full" src="/images/testimonials/caroline.jpg" alt="">
                    </div>
                    <div class="text-base">
                      <span class="font-medium text-poivre-700">Caroline T.</span><span class="text-poivre-500">, Sherbrooke</span>
                    </div>
                  </div>
                </footer>
              </blockquote>
            </div>
          </div>
          <div class="mt-12 sm:mt-16 lg:mt-0">
            <div class="pl-4 pr-4 sm:pl-6 lg:px-0 lg:m-0 lg:relative lg:w-full flex justify-center">
              <img
                class="w-full shadow-xl lg:absolute lg:left-0 lg:w-full rounded-lg border-1 border-tomate"
                src="https://glouton.b-cdn.net/site/images/mockups/shoppinglist2.jpg"
                alt="Liste d'épicerie"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10 bg-white rounded-md shadow">
      <div class="px-4 py-12 mx-auto text-center max-w-8xl sm:px-6 lg:py-16 lg:px-8">
        <h2 class="mb-2 text-3xl font-extrabold tracking-tight text-poivre-800 sm:text-4xl font-title">
          <span class="block">Prêt pour la liste?</span>
        </h2>
        <p class="text-sm text-poivre-600">
          Un compte gratuit est requis pour utiliser notre outil de liste d'épicerie.
        </p>
        <div v-if="!userStore.user" class="flex justify-center mt-5 space-x-3">
          <UButton type="button" icon="i-mdi-login-variant" label="Connexion" @click="modalStore.openLoginModal" />
          <UButton as="a" :to="$localePath({ name: 'RegisterPage' })" label="Créer un compte" />
        </div>
      </div>
    </div>
  </div>
</template>
